import * as Sentry from '@sentry/browser';
import api from './apis/index'

export const common = {
    sentry : Sentry,                //哨兵
    color : {
        danger : "#ff4d4f",         //危险
        primary : "#1890ff",        //主色
        unactivated : "#bec8c8",    //失活
        disable : "#f5f5f5",        //不可用
        success : "#52c41a",        //成功
        warning : "#faad14",        //警告
        purple : "#a26ef4"          //紫色
    }
};

//1    表单
//2    广告
//3    酒店信息
//4    接送机
//5    行程
export enum MeetMenuList {
    Form = 'type1',
    Advertisement = 'type2',
    Hotel = 'type3',
    Plain = 'type4',
    Joruney = 'type5',
}
